import { UserProfile } from '__generated__/GQL';

type UserProfileAddressFields = Pick<
  UserProfile,
  'city' | 'country' | 'street' | 'zip' | 'isAddressFilled'
>;

type UserProfileWithAddress = UserProfileAddressFields & {
  city: string;
  country: string;
  street: string;
  zip: string;
  isAddressFilled: true;
};

/**
 * Function to define a type predicate for userProfile.isAddressFilled
 */
const getIsAddressFilled = (
  userProfile: UserProfileAddressFields,
): userProfile is UserProfileWithAddress => userProfile.isAddressFilled;

export default getIsAddressFilled;
